import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PageSideNavigationGroup } from '@app/shared/models/nav-item.model';
import { DeviceType } from '@app/shared/enum/device-type';
import { Subscription } from 'rxjs';
import { DeviceService } from '@app/shared/helpers/device.service';
import { CONFIG_CAT_KEY } from '@app/shared/enum/feature-flag';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false,
})
export class SidebarComponent implements OnInit, OnDestroy {
    @Input() menu: PageSideNavigationGroup[];

    isMobile = false;
    isSidenavCollapsed = false;
    displayTitle = true;
    deviceTypes = DeviceType;
    featureFlagKey = CONFIG_CAT_KEY.FEATURE_DISCOVERY;

    private deviceTypeSubscription: Subscription;

    constructor(private deviceService: DeviceService) {}

    ngOnInit(): void {
        setTimeout(() => {
            this.deviceTypeSubscription = this.deviceService.deviceType$.subscribe((deviceType) => {
                this.isMobile = deviceType === DeviceType.mobile;
                this.displayTitle = !this.isMobile;
                this.isSidenavCollapsed = this.isMobile;
            });
        });
    }

    toggleSidenav(): void {
        this.isSidenavCollapsed = !this.isSidenavCollapsed;
    }

    ngOnDestroy(): void {
        if (this.deviceTypeSubscription) {
            this.deviceTypeSubscription.unsubscribe();
        }
    }
}
